export enum PartnerStateEnum {
    Reset = 'Reset',
    ShowPartnerProfile = 'ShowPartnerProfile',
    ShowChildrenList = 'ShowChildrenList',
    AddChild = 'AddChild',
    EditChild = 'EditChild',
    ShowOrders = 'ShowOrders',
    ShowOrder = 'ShowOrder',
    PartnerDelete = 'PartnerDelete',
}
